/**
 * Do not edit directly
 * Generated on Tue, 20 Jun 2023 05:36:44 GMT
 */

module.exports = {
  "breakpoint": {
    "small": {
      "value": "544px",
      "filePath": "tokens/breakpoint/breakpoint.json",
      "isSource": true,
      "original": {
        "value": "544px"
      },
      "name": "breakpoint-small",
      "attributes": {},
      "path": [
        "breakpoint",
        "small:"
      ]
    },
    "medium": {
      "value": "768px",
      "filePath": "tokens/breakpoint/breakpoint.json",
      "isSource": true,
      "original": {
        "value": "768px"
      },
      "name": "breakpoint-medium",
      "attributes": {},
      "path": [
        "breakpoint",
        "medium:"
      ]
    },
    "large": {
      "value": "1012px",
      "filePath": "tokens/breakpoint/breakpoint.json",
      "isSource": true,
      "original": {
        "value": "1012px"
      },
      "name": "breakpoint-large",
      "attributes": {},
      "path": [
        "breakpoint",
        "large:"
      ]
    },
    "xlarge": {
      "value": "1280px",
      "filePath": "tokens/breakpoint/breakpoint.json",
      "isSource": true,
      "original": {
        "value": "1280px"
      },
      "name": "breakpoint-xlarge",
      "attributes": {},
      "path": [
        "breakpoint",
        "xlarge:"
      ]
    }
  },
  "color": {
    "primitive": {
      "shepink50": {
        "value": "#FBF7F7",
        "type": "color",
        "description": "背景の色 / 大きめのカードで上にテキストを載せる等の用途であればこちらを推奨",
        "attributes": {
          "figmaName": "Primitive/SHEColors/Pink/50"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#FBF7F7",
          "type": "color",
          "description": "背景の色 / 大きめのカードで上にテキストを載せる等の用途であればこちらを推奨",
          "attributes": {
            "figmaName": "Primitive/SHEColors/Pink/50"
          }
        },
        "name": "color-primitive-shepink-50",
        "path": [
          "color",
          "primitive",
          "shepink-50"
        ]
      },
      "shepink100": {
        "value": "#F9F2F2",
        "type": "color",
        "description": "背景の色 / ラベルなど小さなパーツの背景はこちらを推奨 / YOPPYさん作成のカラーパレットまま色",
        "attributes": {
          "figmaName": "Primitive/SHEColors/Pink/100"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#F9F2F2",
          "type": "color",
          "description": "背景の色 / ラベルなど小さなパーツの背景はこちらを推奨 / YOPPYさん作成のカラーパレットまま色",
          "attributes": {
            "figmaName": "Primitive/SHEColors/Pink/100"
          }
        },
        "name": "color-primitive-shepink-100",
        "path": [
          "color",
          "primitive",
          "shepink-100"
        ]
      },
      "shepink200": {
        "value": "#F2E5E5",
        "type": "color",
        "description": "YOPPYさん作成のカラーパレットまま色",
        "attributes": {
          "figmaName": "Primitive/SHEColors/Pink/200"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#F2E5E5",
          "type": "color",
          "description": "YOPPYさん作成のカラーパレットまま色",
          "attributes": {
            "figmaName": "Primitive/SHEColors/Pink/200"
          }
        },
        "name": "color-primitive-shepink-200",
        "path": [
          "color",
          "primitive",
          "shepink-200"
        ]
      },
      "shepink300": {
        "value": "#EFD6D5",
        "type": "color",
        "description": "YOPPYさん作成のカラーパレットまま色",
        "attributes": {
          "figmaName": "Primitive/SHEColors/Pink/300"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#EFD6D5",
          "type": "color",
          "description": "YOPPYさん作成のカラーパレットまま色",
          "attributes": {
            "figmaName": "Primitive/SHEColors/Pink/300"
          }
        },
        "name": "color-primitive-shepink-300",
        "path": [
          "color",
          "primitive",
          "shepink-300"
        ]
      },
      "shepink400": {
        "value": "#D6A1A1",
        "type": "color",
        "description": "YOPPYさん作成のカラーパレットまま色",
        "attributes": {
          "figmaName": "Primitive/SHEColors/Pink/400"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#D6A1A1",
          "type": "color",
          "description": "YOPPYさん作成のカラーパレットまま色",
          "attributes": {
            "figmaName": "Primitive/SHEColors/Pink/400"
          }
        },
        "name": "color-primitive-shepink-400",
        "path": [
          "color",
          "primitive",
          "shepink-400"
        ]
      },
      "shepink500": {
        "value": "#C38383",
        "type": "color",
        "description": "白背景時に使用できるテキストカラー / 塗りで使用できる一番濃い色",
        "attributes": {
          "figmaName": "Primitive/SHEColors/Pink/500"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#C38383",
          "type": "color",
          "description": "白背景時に使用できるテキストカラー / 塗りで使用できる一番濃い色",
          "attributes": {
            "figmaName": "Primitive/SHEColors/Pink/500"
          }
        },
        "name": "color-primitive-shepink-500",
        "path": [
          "color",
          "primitive",
          "shepink-500"
        ]
      },
      "shepink600": {
        "value": "#BA7D7D",
        "type": "color",
        "description": "背景色の上にのせるテキストカラー / 塗りでは基本的に使用しない",
        "attributes": {
          "figmaName": "Primitive/SHEColors/Pink/600"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#BA7D7D",
          "type": "color",
          "description": "背景色の上にのせるテキストカラー / 塗りでは基本的に使用しない",
          "attributes": {
            "figmaName": "Primitive/SHEColors/Pink/600"
          }
        },
        "name": "color-primitive-shepink-600",
        "path": [
          "color",
          "primitive",
          "shepink-600"
        ]
      },
      "sheblue50": {
        "value": "#F5F9FA",
        "type": "color",
        "description": "背景の色 / 大きめのカードで上にテキストを載せる等の用途であればこちらを推奨",
        "attributes": {
          "figmaName": "Primitive/SHEColors/Blue/50"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#F5F9FA",
          "type": "color",
          "description": "背景の色 / 大きめのカードで上にテキストを載せる等の用途であればこちらを推奨",
          "attributes": {
            "figmaName": "Primitive/SHEColors/Blue/50"
          }
        },
        "name": "color-primitive-sheblue-50",
        "path": [
          "color",
          "primitive",
          "sheblue-50"
        ]
      },
      "sheblue100": {
        "value": "#F0F6F7",
        "type": "color",
        "description": "背景の色 / ラベルなど小さなパーツの背景はこちらを推奨 / YOPPYさん作成のカラーパレットまま色",
        "attributes": {
          "figmaName": "Primitive/SHEColors/Blue/100"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#F0F6F7",
          "type": "color",
          "description": "背景の色 / ラベルなど小さなパーツの背景はこちらを推奨 / YOPPYさん作成のカラーパレットまま色",
          "attributes": {
            "figmaName": "Primitive/SHEColors/Blue/100"
          }
        },
        "name": "color-primitive-sheblue-100",
        "path": [
          "color",
          "primitive",
          "sheblue-100"
        ]
      },
      "sheblue200": {
        "value": "#DFEAED",
        "type": "color",
        "description": "YOPPYさん作成のカラーパレットまま色",
        "attributes": {
          "figmaName": "Primitive/SHEColors/Blue/200"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#DFEAED",
          "type": "color",
          "description": "YOPPYさん作成のカラーパレットまま色",
          "attributes": {
            "figmaName": "Primitive/SHEColors/Blue/200"
          }
        },
        "name": "color-primitive-sheblue-200",
        "path": [
          "color",
          "primitive",
          "sheblue-200"
        ]
      },
      "sheblue300": {
        "value": "#D7E4EA",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/SHEColors/Blue/300"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#D7E4EA",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/SHEColors/Blue/300"
          }
        },
        "name": "color-primitive-sheblue-300",
        "path": [
          "color",
          "primitive",
          "sheblue-300"
        ]
      },
      "sheblue400": {
        "value": "#BAD1DB",
        "type": "color",
        "description": "YOPPYさん作成のカラーパレットまま色",
        "attributes": {
          "figmaName": "Primitive/SHEColors/Blue/400"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#BAD1DB",
          "type": "color",
          "description": "YOPPYさん作成のカラーパレットまま色",
          "attributes": {
            "figmaName": "Primitive/SHEColors/Blue/400"
          }
        },
        "name": "color-primitive-sheblue-400",
        "path": [
          "color",
          "primitive",
          "sheblue-400"
        ]
      },
      "sheblue500": {
        "value": "#6B9BAA",
        "type": "color",
        "description": "YOPPYさん作成のカラーパレットまま色",
        "attributes": {
          "figmaName": "Primitive/SHEColors/Blue/500"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#6B9BAA",
          "type": "color",
          "description": "YOPPYさん作成のカラーパレットまま色",
          "attributes": {
            "figmaName": "Primitive/SHEColors/Blue/500"
          }
        },
        "name": "color-primitive-sheblue-500",
        "path": [
          "color",
          "primitive",
          "sheblue-500"
        ]
      },
      "sheblue600": {
        "value": "#4D8193",
        "type": "color",
        "description": "背景色の上にのせるテキストカラー / 塗りでは基本的に使用しない",
        "attributes": {
          "figmaName": "Primitive/SHEColors/Blue/600"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#4D8193",
          "type": "color",
          "description": "背景色の上にのせるテキストカラー / 塗りでは基本的に使用しない",
          "attributes": {
            "figmaName": "Primitive/SHEColors/Blue/600"
          }
        },
        "name": "color-primitive-sheblue-600",
        "path": [
          "color",
          "primitive",
          "sheblue-600"
        ]
      },
      "shegreen50": {
        "value": "#F6F9F8",
        "type": "color",
        "description": "背景の色 / 大きめのカードで上にテキストを載せる等の用途であればこちらを推奨",
        "attributes": {
          "figmaName": "Primitive/SHEColors/Green/50"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#F6F9F8",
          "type": "color",
          "description": "背景の色 / 大きめのカードで上にテキストを載せる等の用途であればこちらを推奨",
          "attributes": {
            "figmaName": "Primitive/SHEColors/Green/50"
          }
        },
        "name": "color-primitive-shegreen-50",
        "path": [
          "color",
          "primitive",
          "shegreen-50"
        ]
      },
      "shegreen100": {
        "value": "#EFF4F3",
        "type": "color",
        "description": "背景の色 / ラベルなど小さなパーツの背景はこちらを推奨 / YOPPYさん作成のカラーパレットまま色",
        "attributes": {
          "figmaName": "Primitive/SHEColors/Green/100"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#EFF4F3",
          "type": "color",
          "description": "背景の色 / ラベルなど小さなパーツの背景はこちらを推奨 / YOPPYさん作成のカラーパレットまま色",
          "attributes": {
            "figmaName": "Primitive/SHEColors/Green/100"
          }
        },
        "name": "color-primitive-shegreen-100",
        "path": [
          "color",
          "primitive",
          "shegreen-100"
        ]
      },
      "shegreen200": {
        "value": "#E6EFED",
        "type": "color",
        "description": "YOPPYさん作成のカラーパレットまま色",
        "attributes": {
          "figmaName": "Primitive/SHEColors/Green/200"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#E6EFED",
          "type": "color",
          "description": "YOPPYさん作成のカラーパレットまま色",
          "attributes": {
            "figmaName": "Primitive/SHEColors/Green/200"
          }
        },
        "name": "color-primitive-shegreen-200",
        "path": [
          "color",
          "primitive",
          "shegreen-200"
        ]
      },
      "shegreen300": {
        "value": "#CFE0DC",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/SHEColors/Green/300"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#CFE0DC",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/SHEColors/Green/300"
          }
        },
        "name": "color-primitive-shegreen-300",
        "path": [
          "color",
          "primitive",
          "shegreen-300"
        ]
      },
      "shegreen400": {
        "value": "#97B7B6",
        "type": "color",
        "description": "YOPPYさん作成のカラーパレットまま色",
        "attributes": {
          "figmaName": "Primitive/SHEColors/Green/400"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#97B7B6",
          "type": "color",
          "description": "YOPPYさん作成のカラーパレットまま色",
          "attributes": {
            "figmaName": "Primitive/SHEColors/Green/400"
          }
        },
        "name": "color-primitive-shegreen-400",
        "path": [
          "color",
          "primitive",
          "shegreen-400"
        ]
      },
      "shegreen500": {
        "value": "#729897",
        "type": "color",
        "description": "白背景時に使用できるテキストカラー / 塗りで使用できる一番濃い色",
        "attributes": {
          "figmaName": "Primitive/SHEColors/Green/500"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#729897",
          "type": "color",
          "description": "白背景時に使用できるテキストカラー / 塗りで使用できる一番濃い色",
          "attributes": {
            "figmaName": "Primitive/SHEColors/Green/500"
          }
        },
        "name": "color-primitive-shegreen-500",
        "path": [
          "color",
          "primitive",
          "shegreen-500"
        ]
      },
      "shegreen600": {
        "value": "#3E6770",
        "type": "color",
        "description": "背景色の上にのせるテキストカラー / 塗りでは基本的に使用しない / YOPPYさん作成のカラーパレットまま色",
        "attributes": {
          "figmaName": "Primitive/SHEColors/Green/600"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#3E6770",
          "type": "color",
          "description": "背景色の上にのせるテキストカラー / 塗りでは基本的に使用しない / YOPPYさん作成のカラーパレットまま色",
          "attributes": {
            "figmaName": "Primitive/SHEColors/Green/600"
          }
        },
        "name": "color-primitive-shegreen-600",
        "path": [
          "color",
          "primitive",
          "shegreen-600"
        ]
      },
      "black": {
        "value": "#1F2D32",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Black&White/Black"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#1F2D32",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Black&White/Black"
          }
        },
        "name": "color-primitive-black",
        "path": [
          "color",
          "primitive",
          "black"
        ]
      },
      "white": {
        "value": "#FFFFFF",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Black&White/White"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#FFFFFF",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Black&White/White"
          }
        },
        "name": "color-primitive-white",
        "path": [
          "color",
          "primitive",
          "white"
        ]
      },
      "gray0": {
        "value": "#ffffff",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Gray/0"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#ffffff",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Gray/0"
          }
        },
        "name": "color-primitive-gray-0",
        "path": [
          "color",
          "primitive",
          "gray-0"
        ]
      },
      "gray10": {
        "value": "#fbfbfb",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Gray/10"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#fbfbfb",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Gray/10"
          }
        },
        "name": "color-primitive-gray-10",
        "path": [
          "color",
          "primitive",
          "gray-10"
        ]
      },
      "gray20": {
        "value": "#f6f7f7",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Gray/20"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#f6f7f7",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Gray/20"
          }
        },
        "name": "color-primitive-gray-20",
        "path": [
          "color",
          "primitive",
          "gray-20"
        ]
      },
      "gray30": {
        "value": "#edeeef",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Gray/30"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#edeeef",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Gray/30"
          }
        },
        "name": "color-primitive-gray-30",
        "path": [
          "color",
          "primitive",
          "gray-30"
        ]
      },
      "gray40": {
        "value": "#e2e4e4",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Gray/40"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#e2e4e4",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Gray/40"
          }
        },
        "name": "color-primitive-gray-40",
        "path": [
          "color",
          "primitive",
          "gray-40"
        ]
      },
      "gray50": {
        "value": "#c7cbcc",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Gray/50"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#c7cbcc",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Gray/50"
          }
        },
        "name": "color-primitive-gray-50",
        "path": [
          "color",
          "primitive",
          "gray-50"
        ]
      },
      "gray60": {
        "value": "#babebf",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Gray/60"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#babebf",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Gray/60"
          }
        },
        "name": "color-primitive-gray-60",
        "path": [
          "color",
          "primitive",
          "gray-60"
        ]
      },
      "gray70": {
        "value": "#aeb3b5",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Gray/70"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#aeb3b5",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Gray/70"
          }
        },
        "name": "color-primitive-gray-70",
        "path": [
          "color",
          "primitive",
          "gray-70"
        ]
      },
      "gray80": {
        "value": "#a1a7a9",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Gray/80"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#a1a7a9",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Gray/80"
          }
        },
        "name": "color-primitive-gray-80",
        "path": [
          "color",
          "primitive",
          "gray-80"
        ]
      },
      "gray90": {
        "value": "#939a9d",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Gray/90"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#939a9d",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Gray/90"
          }
        },
        "name": "color-primitive-gray-90",
        "path": [
          "color",
          "primitive",
          "gray-90"
        ]
      },
      "gray100": {
        "value": "#849194",
        "type": "color",
        "description": "foundation （Color Generator ）の Profiles Atlassian / Neutral で#1F2D32ベースに作成したグレースケールから文字色としてよりなじむように色味を調整済み",
        "attributes": {
          "figmaName": "Primitive/Gray/100"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#849194",
          "type": "color",
          "description": "foundation （Color Generator ）の Profiles Atlassian / Neutral で#1F2D32ベースに作成したグレースケールから文字色としてよりなじむように色味を調整済み",
          "attributes": {
            "figmaName": "Primitive/Gray/100"
          }
        },
        "name": "color-primitive-gray-100",
        "path": [
          "color",
          "primitive",
          "gray-100"
        ]
      },
      "gray200": {
        "value": "#798184",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Gray/200"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#798184",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Gray/200"
          }
        },
        "name": "color-primitive-gray-200",
        "path": [
          "color",
          "primitive",
          "gray-200"
        ]
      },
      "gray300": {
        "value": "#6b7478",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Gray/300"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#6b7478",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Gray/300"
          }
        },
        "name": "color-primitive-gray-300",
        "path": [
          "color",
          "primitive",
          "gray-300"
        ]
      },
      "gray400": {
        "value": "#606a6d",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Gray/400"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#606a6d",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Gray/400"
          }
        },
        "name": "color-primitive-gray-400",
        "path": [
          "color",
          "primitive",
          "gray-400"
        ]
      },
      "gray500": {
        "value": "#535d61",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Gray/500"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#535d61",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Gray/500"
          }
        },
        "name": "color-primitive-gray-500",
        "path": [
          "color",
          "primitive",
          "gray-500"
        ]
      },
      "gray600": {
        "value": "#475357",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Gray/600"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#475357",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Gray/600"
          }
        },
        "name": "color-primitive-gray-600",
        "path": [
          "color",
          "primitive",
          "gray-600"
        ]
      },
      "gray700": {
        "value": "#384449",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Gray/700"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#384449",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Gray/700"
          }
        },
        "name": "color-primitive-gray-700",
        "path": [
          "color",
          "primitive",
          "gray-700"
        ]
      },
      "gray800": {
        "value": "#2a383c",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Gray/800"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#2a383c",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Gray/800"
          }
        },
        "name": "color-primitive-gray-800",
        "path": [
          "color",
          "primitive",
          "gray-800"
        ]
      },
      "gray900": {
        "value": "#1f2d32",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Gray/900"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#1f2d32",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Gray/900"
          }
        },
        "name": "color-primitive-gray-900",
        "path": [
          "color",
          "primitive",
          "gray-900"
        ]
      },
      "navy50": {
        "value": "#edeff1",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Navy/50"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#edeff1",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Navy/50"
          }
        },
        "name": "color-primitive-navy-50",
        "path": [
          "color",
          "primitive",
          "navy-50"
        ]
      },
      "navy75": {
        "value": "#b6bec5",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Navy/75"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#b6bec5",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Navy/75"
          }
        },
        "name": "color-primitive-navy-75",
        "path": [
          "color",
          "primitive",
          "navy-75"
        ]
      },
      "navy100": {
        "value": "#97a3ad",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Navy/100"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#97a3ad",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Navy/100"
          }
        },
        "name": "color-primitive-navy-100",
        "path": [
          "color",
          "primitive",
          "navy-100"
        ]
      },
      "navy200": {
        "value": "#6a7b8a",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Navy/200"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#6a7b8a",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Navy/200"
          }
        },
        "name": "color-primitive-navy-200",
        "path": [
          "color",
          "primitive",
          "navy-200"
        ]
      },
      "navy300": {
        "value": "#4c6072",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Navy/300"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#4c6072",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Navy/300"
          }
        },
        "name": "color-primitive-navy-300",
        "path": [
          "color",
          "primitive",
          "navy-300"
        ]
      },
      "navy400": {
        "value": "#354350",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Navy/400"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#354350",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Navy/400"
          }
        },
        "name": "color-primitive-navy-400",
        "path": [
          "color",
          "primitive",
          "navy-400"
        ]
      },
      "navy500": {
        "value": "#2e3b46",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Navy/500"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#2e3b46",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Navy/500"
          }
        },
        "name": "color-primitive-navy-500",
        "path": [
          "color",
          "primitive",
          "navy-500"
        ]
      },
      "red40": {
        "value": "#FDF6F8",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Red/40"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#FDF6F8",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Red/40"
          }
        },
        "name": "color-primitive-red-40",
        "path": [
          "color",
          "primitive",
          "red-40"
        ]
      },
      "red50": {
        "value": "#fceef1",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Red/50"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#fceef1",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Red/50"
          }
        },
        "name": "color-primitive-red-50",
        "path": [
          "color",
          "primitive",
          "red-50"
        ]
      },
      "red75": {
        "value": "#f2b9c6",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Red/75"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#f2b9c6",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Red/75"
          }
        },
        "name": "color-primitive-red-75",
        "path": [
          "color",
          "primitive",
          "red-75"
        ]
      },
      "red100": {
        "value": "#ec9caf",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Red/100"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#ec9caf",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Red/100"
          }
        },
        "name": "color-primitive-red-100",
        "path": [
          "color",
          "primitive",
          "red-100"
        ]
      },
      "red200": {
        "value": "#e4718c",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Red/200"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#e4718c",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Red/200"
          }
        },
        "name": "color-primitive-red-200",
        "path": [
          "color",
          "primitive",
          "red-200"
        ]
      },
      "red300": {
        "value": "#df5475",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Red/300"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#df5475",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Red/300"
          }
        },
        "name": "color-primitive-red-300",
        "path": [
          "color",
          "primitive",
          "red-300"
        ]
      },
      "red350": {
        "value": "#C34160",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Red/350"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#C34160",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Red/350"
          }
        },
        "name": "color-primitive-red-350",
        "path": [
          "color",
          "primitive",
          "red-350"
        ]
      },
      "red400": {
        "value": "#9c3b52",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Red/400"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#9c3b52",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Red/400"
          }
        },
        "name": "color-primitive-red-400",
        "path": [
          "color",
          "primitive",
          "red-400"
        ]
      },
      "red500": {
        "value": "#883347",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Red/500"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#883347",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Red/500"
          }
        },
        "name": "color-primitive-red-500",
        "path": [
          "color",
          "primitive",
          "red-500"
        ]
      },
      "green40": {
        "value": "#F5FAF4",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Green/40"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#F5FAF4",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Green/40"
          }
        },
        "name": "color-primitive-green-40",
        "path": [
          "color",
          "primitive",
          "green-40"
        ]
      },
      "green50": {
        "value": "#edf7ec",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Green/50"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#edf7ec",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Green/50"
          }
        },
        "name": "color-primitive-green-50",
        "path": [
          "color",
          "primitive",
          "green-50"
        ]
      },
      "green75": {
        "value": "#b5deb2",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Green/75"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#b5deb2",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Green/75"
          }
        },
        "name": "color-primitive-green-75",
        "path": [
          "color",
          "primitive",
          "green-75"
        ]
      },
      "green100": {
        "value": "#96d091",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Green/100"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#96d091",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Green/100"
          }
        },
        "name": "color-primitive-green-100",
        "path": [
          "color",
          "primitive",
          "green-100"
        ]
      },
      "green200": {
        "value": "#69bc62",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Green/200"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#69bc62",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Green/200"
          }
        },
        "name": "color-primitive-green-200",
        "path": [
          "color",
          "primitive",
          "green-200"
        ]
      },
      "green300": {
        "value": "#4aae42",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Green/300"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#4aae42",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Green/300"
          }
        },
        "name": "color-primitive-green-300",
        "path": [
          "color",
          "primitive",
          "green-300"
        ]
      },
      "green400": {
        "value": "#347a2e",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Green/400"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#347a2e",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Green/400"
          }
        },
        "name": "color-primitive-green-400",
        "path": [
          "color",
          "primitive",
          "green-400"
        ]
      },
      "green500": {
        "value": "#2d6a28",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Green/500"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#2d6a28",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Green/500"
          }
        },
        "name": "color-primitive-green-500",
        "path": [
          "color",
          "primitive",
          "green-500"
        ]
      },
      "blue50": {
        "value": "#eaf3fc",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Blue/50"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#eaf3fc",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Blue/50"
          }
        },
        "name": "color-primitive-blue-50",
        "path": [
          "color",
          "primitive",
          "blue-50"
        ]
      },
      "blue75": {
        "value": "#a8cff1",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Blue/75"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#a8cff1",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Blue/75"
          }
        },
        "name": "color-primitive-blue-75",
        "path": [
          "color",
          "primitive",
          "blue-75"
        ]
      },
      "blue100": {
        "value": "#84bbec",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Blue/100"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#84bbec",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Blue/100"
          }
        },
        "name": "color-primitive-blue-100",
        "path": [
          "color",
          "primitive",
          "blue-100"
        ]
      },
      "blue200": {
        "value": "#4f9ee4",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Blue/200"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#4f9ee4",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Blue/200"
          }
        },
        "name": "color-primitive-blue-200",
        "path": [
          "color",
          "primitive",
          "blue-200"
        ]
      },
      "blue300": {
        "value": "#2b8ade",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Blue/300"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#2b8ade",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Blue/300"
          }
        },
        "name": "color-primitive-blue-300",
        "path": [
          "color",
          "primitive",
          "blue-300"
        ]
      },
      "blue400": {
        "value": "#1e619b",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Blue/400"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#1e619b",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Blue/400"
          }
        },
        "name": "color-primitive-blue-400",
        "path": [
          "color",
          "primitive",
          "blue-400"
        ]
      },
      "blue500": {
        "value": "#1a5487",
        "type": "color",
        "attributes": {
          "figmaName": "Primitive/Blue/500"
        },
        "filePath": "tokens/color/primitive.json",
        "isSource": true,
        "original": {
          "value": "#1a5487",
          "type": "color",
          "attributes": {
            "figmaName": "Primitive/Blue/500"
          }
        },
        "name": "color-primitive-blue-500",
        "path": [
          "color",
          "primitive",
          "blue-500"
        ]
      }
    },
    "bg": {
      "white": {
        "value": "#FFFFFF",
        "type": "color",
        "attributes": {
          "figmaName": "Background/white"
        },
        "filePath": "tokens/color/semantics/background.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.white.value}",
          "type": "color",
          "attributes": {
            "figmaName": "Background/white"
          }
        },
        "name": "color-bg-white",
        "path": [
          "color",
          "bg",
          "white"
        ]
      },
      "gray": {
        "value": "#f6f7f7",
        "type": "color",
        "attributes": {
          "figmaName": "Background/gray"
        },
        "filePath": "tokens/color/semantics/background.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.gray-20.value}",
          "type": "color",
          "attributes": {
            "figmaName": "Background/gray"
          }
        },
        "name": "color-bg-gray",
        "path": [
          "color",
          "bg",
          "gray"
        ]
      },
      "danger": {
        "value": "#FDF6F8",
        "type": "color",
        "attributes": {
          "figmaName": "Background/danger"
        },
        "filePath": "tokens/color/semantics/background.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.red-40.value}",
          "type": "color",
          "attributes": {
            "figmaName": "Background/danger"
          }
        },
        "name": "color-bg-danger",
        "path": [
          "color",
          "bg",
          "danger"
        ]
      },
      "success": {
        "value": "#F5FAF4",
        "type": "color",
        "attributes": {
          "figmaName": "Background/success"
        },
        "filePath": "tokens/color/semantics/background.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.green-40.value}",
          "type": "color",
          "attributes": {
            "figmaName": "Background/success"
          }
        },
        "name": "color-bg-success",
        "path": [
          "color",
          "bg",
          "success"
        ]
      },
      "shepinkLight": {
        "value": "#FBF7F7",
        "type": "color",
        "attributes": {
          "figmaName": "Background/SHEPink/light"
        },
        "filePath": "tokens/color/semantics/background.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.shepink-50.value}",
          "type": "color",
          "attributes": {
            "figmaName": "Background/SHEPink/light"
          }
        },
        "name": "color-bg-shepink-light",
        "path": [
          "color",
          "bg",
          "shepink-light"
        ]
      },
      "shepinkDefault": {
        "value": "#F9F2F2",
        "type": "color",
        "attributes": {
          "figmaName": "Background/SHEPink/default"
        },
        "filePath": "tokens/color/semantics/background.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.shepink-100.value}",
          "type": "color",
          "attributes": {
            "figmaName": "Background/SHEPink/default"
          }
        },
        "name": "color-bg-shepink-default",
        "path": [
          "color",
          "bg",
          "shepink-default"
        ]
      },
      "sheblueLight": {
        "value": "#F5F9FA",
        "type": "color",
        "attributes": {
          "figmaName": "Background/SHEBlue/light"
        },
        "filePath": "tokens/color/semantics/background.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.sheblue-50.value}",
          "type": "color",
          "attributes": {
            "figmaName": "Background/SHEBlue/light"
          }
        },
        "name": "color-bg-sheblue-light",
        "path": [
          "color",
          "bg",
          "sheblue-light"
        ]
      },
      "sheblueDefault": {
        "value": "#F0F6F7",
        "type": "color",
        "attributes": {
          "figmaName": "Background/SHEBlue/default"
        },
        "filePath": "tokens/color/semantics/background.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.sheblue-100.value}",
          "type": "color",
          "attributes": {
            "figmaName": "Background/SHEBlue/default"
          }
        },
        "name": "color-bg-sheblue-default",
        "path": [
          "color",
          "bg",
          "sheblue-default"
        ]
      },
      "shegreenLight": {
        "value": "#F6F9F8",
        "type": "color",
        "attributes": {
          "figmaName": "Background/SHEGreen/light"
        },
        "filePath": "tokens/color/semantics/background.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.shegreen-50.value}",
          "type": "color",
          "attributes": {
            "figmaName": "Background/SHEGreen/light"
          }
        },
        "name": "color-bg-shegreen-light",
        "path": [
          "color",
          "bg",
          "shegreen-light"
        ]
      },
      "shegreenDefault": {
        "value": "#EFF4F3",
        "type": "color",
        "attributes": {
          "figmaName": "Background/SHEGreen/default"
        },
        "filePath": "tokens/color/semantics/background.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.shegreen-100.value}",
          "type": "color",
          "attributes": {
            "figmaName": "Background/SHEGreen/default"
          }
        },
        "name": "color-bg-shegreen-default",
        "path": [
          "color",
          "bg",
          "shegreen-default"
        ]
      }
    },
    "border": {
      "default": {
        "value": "#edeeef",
        "type": "color",
        "attributes": {
          "figmaName": "Border/default"
        },
        "description": "背景がWhiteの場合に使用する基本のボーダーの色",
        "filePath": "tokens/color/semantics/border.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.gray-30.value}",
          "type": "color",
          "attributes": {
            "figmaName": "Border/default"
          },
          "description": "背景がWhiteの場合に使用する基本のボーダーの色"
        },
        "name": "color-border-default",
        "path": [
          "color",
          "border",
          "default"
        ]
      },
      "darken": {
        "value": "#e2e4e4",
        "type": "color",
        "attributes": {
          "figmaName": "Border/darken"
        },
        "description": "背景がgrayの場合に使用するボーダーの色",
        "filePath": "tokens/color/semantics/border.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.gray-40.value}",
          "type": "color",
          "attributes": {
            "figmaName": "Border/darken"
          },
          "description": "背景がgrayの場合に使用するボーダーの色"
        },
        "name": "color-border-darken",
        "path": [
          "color",
          "border",
          "darken"
        ]
      }
    },
    "button": {
      "primary": {
        "bgDefault": {
          "value": "#4c6072",
          "type": "color",
          "attributes": {
            "figmaName": "Button/Primary/Background/Default"
          },
          "filePath": "tokens/color/semantics/button.json",
          "isSource": true,
          "original": {
            "value": "{color.primitive.navy-300.value}",
            "type": "color",
            "attributes": {
              "figmaName": "Button/Primary/Background/Default"
            }
          },
          "name": "color-button-primary-bg-default",
          "path": [
            "color",
            "button",
            "primary",
            "bg-default"
          ]
        },
        "bgHover": {
          "value": "#354350",
          "type": "color",
          "attributes": {
            "figmaName": "Button/Primary/Background/Hover"
          },
          "filePath": "tokens/color/semantics/button.json",
          "isSource": true,
          "original": {
            "value": "{color.primitive.navy-400.value}",
            "type": "color",
            "attributes": {
              "figmaName": "Button/Primary/Background/Hover"
            }
          },
          "name": "color-button-primary-bg-hover",
          "path": [
            "color",
            "button",
            "primary",
            "bg-hover"
          ]
        },
        "bgDisabled": {
          "value": "#e2e4e4",
          "type": "color",
          "attributes": {
            "figmaName": "Button/Primary/Background/Disabled"
          },
          "filePath": "tokens/color/semantics/button.json",
          "isSource": true,
          "original": {
            "value": "{color.primitive.gray-40.value}",
            "type": "color",
            "attributes": {
              "figmaName": "Button/Primary/Background/Disabled"
            }
          },
          "name": "color-button-primary-bg-disabled",
          "path": [
            "color",
            "button",
            "primary",
            "bg-disabled"
          ]
        },
        "borderDefault": {
          "value": "#4c6072",
          "type": "color",
          "attributes": {
            "figmaName": "Button/Primary/Border/Default"
          },
          "filePath": "tokens/color/semantics/button.json",
          "isSource": true,
          "original": {
            "value": "{color.primitive.navy-300.value}",
            "type": "color",
            "attributes": {
              "figmaName": "Button/Primary/Border/Default"
            }
          },
          "name": "color-button-primary-border-default",
          "path": [
            "color",
            "button",
            "primary",
            "border-default"
          ]
        },
        "borderHover": {
          "value": "#354350",
          "type": "color",
          "attributes": {
            "figmaName": "Button/Primary/Border/Hover"
          },
          "filePath": "tokens/color/semantics/button.json",
          "isSource": true,
          "original": {
            "value": "{color.primitive.navy-400.value}",
            "type": "color",
            "attributes": {
              "figmaName": "Button/Primary/Border/Hover"
            }
          },
          "name": "color-button-primary-border-hover",
          "path": [
            "color",
            "button",
            "primary",
            "border-hover"
          ]
        },
        "borderDisabled": {
          "value": "#e2e4e4",
          "type": "color",
          "attributes": {
            "figmaName": "Button/Primary/Border/Disabled"
          },
          "filePath": "tokens/color/semantics/button.json",
          "isSource": true,
          "original": {
            "value": "{color.primitive.gray-40.value}",
            "type": "color",
            "attributes": {
              "figmaName": "Button/Primary/Border/Disabled"
            }
          },
          "name": "color-button-primary-border-disabled",
          "path": [
            "color",
            "button",
            "primary",
            "border-disabled"
          ]
        },
        "textDefault": {
          "value": "#FFFFFF",
          "type": "color",
          "attributes": {
            "figmaName": "Button/Primary/Text/Default"
          },
          "filePath": "tokens/color/semantics/button.json",
          "isSource": true,
          "original": {
            "value": "{color.text.white.value}",
            "type": "color",
            "attributes": {
              "figmaName": "Button/Primary/Text/Default"
            }
          },
          "name": "color-button-primary-text-default",
          "path": [
            "color",
            "button",
            "primary",
            "text-default"
          ]
        },
        "textDisabled": {
          "value": "#c7cbcc",
          "type": "color",
          "attributes": {
            "figmaName": "Button/Primary/Text/Disabled"
          },
          "filePath": "tokens/color/semantics/button.json",
          "isSource": true,
          "original": {
            "value": "{color.text.disabled.value}",
            "type": "color",
            "attributes": {
              "figmaName": "Button/Primary/Text/Disabled"
            }
          },
          "name": "color-button-primary-text-disabled",
          "path": [
            "color",
            "button",
            "primary",
            "text-disabled"
          ]
        }
      },
      "secondary": {
        "bgHover": {
          "value": "rgba(76, 96, 114, 0.1)",
          "type": "color",
          "attributes": {
            "figmaName": "Button/Secondary/Background/Default"
          },
          "filePath": "tokens/color/semantics/button.json",
          "isSource": true,
          "original": {
            "value": "rgba(76, 96, 114, 0.1)",
            "type": "color",
            "attributes": {
              "figmaName": "Button/Secondary/Background/Default"
            }
          },
          "name": "color-button-secondary-bg-hover",
          "path": [
            "color",
            "button",
            "secondary",
            "bg-hover"
          ]
        },
        "borderDefault": {
          "value": "#4c6072",
          "type": "color",
          "attributes": {
            "figmaName": "Button/Secondary/Border/Default"
          },
          "filePath": "tokens/color/semantics/button.json",
          "isSource": true,
          "original": {
            "value": "{color.primitive.navy-300.value}",
            "type": "color",
            "attributes": {
              "figmaName": "Button/Secondary/Border/Default"
            }
          },
          "name": "color-button-secondary-border-default",
          "path": [
            "color",
            "button",
            "secondary",
            "border-default"
          ]
        },
        "borderDisabled": {
          "value": "#c7cbcc",
          "type": "color",
          "attributes": {
            "figmaName": "Button/Secondary/Border/Disabled"
          },
          "filePath": "tokens/color/semantics/button.json",
          "isSource": true,
          "original": {
            "value": "{color.primitive.gray-50.value}",
            "type": "color",
            "attributes": {
              "figmaName": "Button/Secondary/Border/Disabled"
            }
          },
          "name": "color-button-secondary-border-disabled",
          "path": [
            "color",
            "button",
            "secondary",
            "border-disabled"
          ]
        },
        "textDefault": {
          "value": "#4c6072",
          "type": "color",
          "attributes": {
            "figmaName": "Button/Secondary/Text/Default"
          },
          "filePath": "tokens/color/semantics/button.json",
          "isSource": true,
          "original": {
            "value": "{color.text.primary.value}",
            "type": "color",
            "attributes": {
              "figmaName": "Button/Secondary/Text/Default"
            }
          },
          "name": "color-button-secondary-text-default",
          "path": [
            "color",
            "button",
            "secondary",
            "text-default"
          ]
        },
        "textDisabled": {
          "value": "#c7cbcc",
          "type": "color",
          "attributes": {
            "figmaName": "Button/Secondary/Text/Disabled"
          },
          "filePath": "tokens/color/semantics/button.json",
          "isSource": true,
          "original": {
            "value": "{color.text.disabled.value}",
            "type": "color",
            "attributes": {
              "figmaName": "Button/Secondary/Text/Disabled"
            }
          },
          "name": "color-button-secondary-text-disabled",
          "path": [
            "color",
            "button",
            "secondary",
            "text-disabled"
          ]
        }
      },
      "danger": {
        "bgDefault": {
          "value": "#df5475",
          "type": "color",
          "attributes": {
            "figmaName": "Button/Danger/Background/Default"
          },
          "filePath": "tokens/color/semantics/button.json",
          "isSource": true,
          "original": {
            "value": "{color.primitive.red-300.value}",
            "type": "color",
            "attributes": {
              "figmaName": "Button/Danger/Background/Default"
            }
          },
          "name": "color-button-danger-bg-default",
          "path": [
            "color",
            "button",
            "danger",
            "bg-default"
          ]
        },
        "bgHover": {
          "value": "#C34160",
          "type": "color",
          "attributes": {
            "figmaName": "Button/Danger/Background/Hover"
          },
          "filePath": "tokens/color/semantics/button.json",
          "isSource": true,
          "original": {
            "value": "{color.primitive.red-350.value}",
            "type": "color",
            "attributes": {
              "figmaName": "Button/Danger/Background/Hover"
            }
          },
          "name": "color-button-danger-bg-hover",
          "path": [
            "color",
            "button",
            "danger",
            "bg-hover"
          ]
        },
        "bgDisabled": {
          "value": "#e2e4e4",
          "type": "color",
          "attributes": {
            "figmaName": "Button/Danger/Background/Disabled"
          },
          "filePath": "tokens/color/semantics/button.json",
          "isSource": true,
          "original": {
            "value": "{color.primitive.gray-40.value}",
            "type": "color",
            "attributes": {
              "figmaName": "Button/Danger/Background/Disabled"
            }
          },
          "name": "color-button-danger-bg-disabled",
          "path": [
            "color",
            "button",
            "danger",
            "bg-disabled"
          ]
        },
        "borderDefault": {
          "value": "#df5475",
          "type": "color",
          "attributes": {
            "figmaName": "Button/Danger/Border/Default"
          },
          "filePath": "tokens/color/semantics/button.json",
          "isSource": true,
          "original": {
            "value": "{color.primitive.red-300.value}",
            "type": "color",
            "attributes": {
              "figmaName": "Button/Danger/Border/Default"
            }
          },
          "name": "color-button-danger-border-default",
          "path": [
            "color",
            "button",
            "danger",
            "border-default"
          ]
        },
        "borderHover": {
          "value": "#C34160",
          "type": "color",
          "attributes": {
            "figmaName": "Button/Danger/Border/Hover"
          },
          "filePath": "tokens/color/semantics/button.json",
          "isSource": true,
          "original": {
            "value": "{color.primitive.red-350.value}",
            "type": "color",
            "attributes": {
              "figmaName": "Button/Danger/Border/Hover"
            }
          },
          "name": "color-button-danger-border-hover",
          "path": [
            "color",
            "button",
            "danger",
            "border-hover"
          ]
        },
        "borderDisabled": {
          "value": "#e2e4e4",
          "type": "color",
          "attributes": {
            "figmaName": "Button/Danger/Border/Disabled"
          },
          "filePath": "tokens/color/semantics/button.json",
          "isSource": true,
          "original": {
            "value": "{color.primitive.gray-40.value}",
            "type": "color",
            "attributes": {
              "figmaName": "Button/Danger/Border/Disabled"
            }
          },
          "name": "color-button-danger-border-disabled",
          "path": [
            "color",
            "button",
            "danger",
            "border-disabled"
          ]
        },
        "textDefault": {
          "value": "#FFFFFF",
          "type": "color",
          "attributes": {
            "figmaName": "Button/Danger/Text/Default"
          },
          "filePath": "tokens/color/semantics/button.json",
          "isSource": true,
          "original": {
            "value": "{color.text.white.value}",
            "type": "color",
            "attributes": {
              "figmaName": "Button/Danger/Text/Default"
            }
          },
          "name": "color-button-danger-text-default",
          "path": [
            "color",
            "button",
            "danger",
            "text-default"
          ]
        },
        "textDisabled": {
          "value": "#c7cbcc",
          "type": "color",
          "attributes": {
            "figmaName": "Button/Danger/Text/Disabled"
          },
          "filePath": "tokens/color/semantics/button.json",
          "isSource": true,
          "original": {
            "value": "{color.text.disabled.value}",
            "type": "color",
            "attributes": {
              "figmaName": "Button/Danger/Text/Disabled"
            }
          },
          "name": "color-button-danger-text-disabled",
          "path": [
            "color",
            "button",
            "danger",
            "text-disabled"
          ]
        }
      }
    },
    "function": {
      "primaryDefault": {
        "value": "#4c6072",
        "type": "color",
        "attributes": {
          "figmaName": "Function/Primary/default"
        },
        "filePath": "tokens/color/semantics/function.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.navy-300.value}",
          "type": "color",
          "attributes": {
            "figmaName": "Function/Primary/default"
          }
        },
        "name": "color-function-primary-default",
        "path": [
          "color",
          "function",
          "primary-default"
        ]
      },
      "dangerDefault": {
        "value": "#df5475",
        "type": "color",
        "attributes": {
          "figmaName": "Function/Danger/default"
        },
        "filePath": "tokens/color/semantics/function.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.red-300.value}",
          "type": "color",
          "attributes": {
            "figmaName": "Function/Danger/default"
          }
        },
        "name": "color-function-danger-default",
        "path": [
          "color",
          "function",
          "danger-default"
        ]
      },
      "successDefault": {
        "value": "#4aae42",
        "type": "color",
        "description": "成功系の色",
        "attributes": {
          "figmaName": "Function/Success/default"
        },
        "filePath": "tokens/color/semantics/function.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.green-300.value}",
          "type": "color",
          "description": "成功系の色",
          "attributes": {
            "figmaName": "Function/Success/default"
          }
        },
        "name": "color-function-success-default",
        "path": [
          "color",
          "function",
          "success-default"
        ]
      },
      "textlinkDefault": {
        "value": "#2b8ade",
        "type": "color",
        "description": "テキストリンク用の色",
        "attributes": {
          "figmaName": "Function/TextLink/default"
        },
        "filePath": "tokens/color/semantics/function.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.blue-300.value}",
          "type": "color",
          "description": "テキストリンク用の色",
          "attributes": {
            "figmaName": "Function/TextLink/default"
          }
        },
        "name": "color-function-textlink-default",
        "path": [
          "color",
          "function",
          "textlink-default"
        ]
      }
    },
    "object": {
      "shepinkLightest": {
        "value": "#F2E5E5",
        "type": "color",
        "attributes": {
          "figmaName": "Object/SHEPink/lightest"
        },
        "filePath": "tokens/color/semantics/object.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.shepink-200.value}",
          "type": "color",
          "attributes": {
            "figmaName": "Object/SHEPink/lightest"
          }
        },
        "name": "color-object-shepink-lightest",
        "path": [
          "color",
          "object",
          "shepink-lightest"
        ]
      },
      "shepinkLight": {
        "value": "#EFD6D5",
        "type": "color",
        "attributes": {
          "figmaName": "Object/SHEPink/light"
        },
        "filePath": "tokens/color/semantics/object.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.shepink-300.value}",
          "type": "color",
          "attributes": {
            "figmaName": "Object/SHEPink/light"
          }
        },
        "name": "color-object-shepink-light",
        "path": [
          "color",
          "object",
          "shepink-light"
        ]
      },
      "shepinkNormal": {
        "value": "#D6A1A1",
        "type": "color",
        "attributes": {
          "figmaName": "Object/SHEPink/normal"
        },
        "filePath": "tokens/color/semantics/object.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.shepink-400.value}",
          "type": "color",
          "attributes": {
            "figmaName": "Object/SHEPink/normal"
          }
        },
        "name": "color-object-shepink-normal",
        "path": [
          "color",
          "object",
          "shepink-normal"
        ]
      },
      "shepinkDarken": {
        "value": "#C38383",
        "type": "color",
        "attributes": {
          "figmaName": "Object/SHEPink/darken"
        },
        "filePath": "tokens/color/semantics/object.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.shepink-500.value}",
          "type": "color",
          "attributes": {
            "figmaName": "Object/SHEPink/darken"
          }
        },
        "name": "color-object-shepink-darken",
        "path": [
          "color",
          "object",
          "shepink-darken"
        ]
      },
      "sheblueLightest": {
        "value": "#DFEAED",
        "type": "color",
        "attributes": {
          "figmaName": "Object/SHEBlue/lightest"
        },
        "filePath": "tokens/color/semantics/object.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.sheblue-200.value}",
          "type": "color",
          "attributes": {
            "figmaName": "Object/SHEBlue/lightest"
          }
        },
        "name": "color-object-sheblue-lightest",
        "path": [
          "color",
          "object",
          "sheblue-lightest"
        ]
      },
      "sheblueLight": {
        "value": "#D7E4EA",
        "type": "color",
        "attributes": {
          "figmaName": "Object/SHEBlue/light"
        },
        "filePath": "tokens/color/semantics/object.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.sheblue-300.value}",
          "type": "color",
          "attributes": {
            "figmaName": "Object/SHEBlue/light"
          }
        },
        "name": "color-object-sheblue-light",
        "path": [
          "color",
          "object",
          "sheblue-light"
        ]
      },
      "sheblueNormal": {
        "value": "#BAD1DB",
        "type": "color",
        "attributes": {
          "figmaName": "Object/SHEBlue/normal"
        },
        "filePath": "tokens/color/semantics/object.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.sheblue-400.value}",
          "type": "color",
          "attributes": {
            "figmaName": "Object/SHEBlue/normal"
          }
        },
        "name": "color-object-sheblue-normal",
        "path": [
          "color",
          "object",
          "sheblue-normal"
        ]
      },
      "sheblueDarken": {
        "value": "#6B9BAA",
        "type": "color",
        "attributes": {
          "figmaName": "Object/SHEBlue/darken"
        },
        "filePath": "tokens/color/semantics/object.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.sheblue-500.value}",
          "type": "color",
          "attributes": {
            "figmaName": "Object/SHEBlue/darken"
          }
        },
        "name": "color-object-sheblue-darken",
        "path": [
          "color",
          "object",
          "sheblue-darken"
        ]
      },
      "shegreenLightest": {
        "value": "#E6EFED",
        "type": "color",
        "attributes": {
          "figmaName": "Object/SHEGreen/lightest"
        },
        "filePath": "tokens/color/semantics/object.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.shegreen-200.value}",
          "type": "color",
          "attributes": {
            "figmaName": "Object/SHEGreen/lightest"
          }
        },
        "name": "color-object-shegreen-lightest",
        "path": [
          "color",
          "object",
          "shegreen-lightest"
        ]
      },
      "shegreenLight": {
        "value": "#CFE0DC",
        "type": "color",
        "attributes": {
          "figmaName": "Object/SHEGreen/light"
        },
        "filePath": "tokens/color/semantics/object.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.shegreen-300.value}",
          "type": "color",
          "attributes": {
            "figmaName": "Object/SHEGreen/light"
          }
        },
        "name": "color-object-shegreen-light",
        "path": [
          "color",
          "object",
          "shegreen-light"
        ]
      },
      "shegreenNormal": {
        "value": "#97B7B6",
        "type": "color",
        "attributes": {
          "figmaName": "Object/SHEGreen/normal"
        },
        "filePath": "tokens/color/semantics/object.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.shegreen-400.value}",
          "type": "color",
          "attributes": {
            "figmaName": "Object/SHEGreen/normal"
          }
        },
        "name": "color-object-shegreen-normal",
        "path": [
          "color",
          "object",
          "shegreen-normal"
        ]
      },
      "shegreenDarken": {
        "value": "#729897",
        "type": "color",
        "attributes": {
          "figmaName": "Object/SHEGreen/darken"
        },
        "filePath": "tokens/color/semantics/object.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.shegreen-500.value}",
          "type": "color",
          "attributes": {
            "figmaName": "Object/SHEGreen/darken"
          }
        },
        "name": "color-object-shegreen-darken",
        "path": [
          "color",
          "object",
          "shegreen-darken"
        ]
      },
      "gray1": {
        "value": "#f6f7f7",
        "type": "color",
        "attributes": {
          "figmaName": "Object/Gray/1"
        },
        "filePath": "tokens/color/semantics/object.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.gray-20.value}",
          "type": "color",
          "attributes": {
            "figmaName": "Object/Gray/1"
          }
        },
        "name": "color-object-gray-1",
        "path": [
          "color",
          "object",
          "gray-1"
        ]
      },
      "gray2": {
        "value": "#e2e4e4",
        "type": "color",
        "attributes": {
          "figmaName": "Object/Gray/2"
        },
        "filePath": "tokens/color/semantics/object.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.gray-40.value}",
          "type": "color",
          "attributes": {
            "figmaName": "Object/Gray/2"
          }
        },
        "name": "color-object-gray-2",
        "path": [
          "color",
          "object",
          "gray-2"
        ]
      },
      "gray3": {
        "value": "#c7cbcc",
        "type": "color",
        "description": "ex. disabledやアクティブではない要素",
        "attributes": {
          "figmaName": "Object/Gray/3"
        },
        "filePath": "tokens/color/semantics/object.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.gray-50.value}",
          "type": "color",
          "description": "ex. disabledやアクティブではない要素",
          "attributes": {
            "figmaName": "Object/Gray/3"
          }
        },
        "name": "color-object-gray-3",
        "path": [
          "color",
          "object",
          "gray-3"
        ]
      },
      "gray4": {
        "value": "#a1a7a9",
        "type": "color",
        "description": "ex. disabledではないがグレーのオブジェクトを乗せたい場合の色",
        "attributes": {
          "figmaName": "Object/Gray/4"
        },
        "filePath": "tokens/color/semantics/object.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.gray-80.value}",
          "type": "color",
          "description": "ex. disabledではないがグレーのオブジェクトを乗せたい場合の色",
          "attributes": {
            "figmaName": "Object/Gray/4"
          }
        },
        "name": "color-object-gray-4",
        "path": [
          "color",
          "object",
          "gray-4"
        ]
      },
      "white": {
        "value": "#FFFFFF",
        "type": "color",
        "attributes": {
          "figmaName": "Object/White"
        },
        "filePath": "tokens/color/semantics/object.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.white.value}",
          "type": "color",
          "attributes": {
            "figmaName": "Object/White"
          }
        },
        "name": "color-object-white",
        "path": [
          "color",
          "object",
          "white"
        ]
      }
    },
    "overlay": {
      "default": {
        "value": "rgba(207, 215, 226, 0.72)",
        "type": "color",
        "description": "基本のオーバーレイの色",
        "attributes": {
          "figmaName": "Overlay/default"
        },
        "filePath": "tokens/color/semantics/overlay.json",
        "isSource": true,
        "original": {
          "value": "rgba(207, 215, 226, 0.72)",
          "type": "color",
          "description": "基本のオーバーレイの色",
          "attributes": {
            "figmaName": "Overlay/default"
          }
        },
        "name": "color-overlay-default",
        "path": [
          "color",
          "overlay",
          "default"
        ]
      }
    },
    "text": {
      "white": {
        "value": "#FFFFFF",
        "type": "color",
        "attributes": {
          "figmaName": "Text/white"
        },
        "filePath": "tokens/color/semantics/text.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.white.value}",
          "type": "color",
          "attributes": {
            "figmaName": "Text/white"
          }
        },
        "name": "color-text-white",
        "path": [
          "color",
          "text",
          "white"
        ]
      },
      "default": {
        "value": "#1F2D32",
        "type": "color",
        "attributes": {
          "figmaName": "Text/default"
        },
        "filePath": "tokens/color/semantics/text.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.black.value}",
          "type": "color",
          "attributes": {
            "figmaName": "Text/default"
          }
        },
        "name": "color-text-default",
        "path": [
          "color",
          "text",
          "default"
        ]
      },
      "weak": {
        "value": "#849194",
        "type": "color",
        "attributes": {
          "figmaName": "Text/weak"
        },
        "filePath": "tokens/color/semantics/text.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.gray-100.value}",
          "type": "color",
          "attributes": {
            "figmaName": "Text/weak"
          }
        },
        "name": "color-text-weak",
        "path": [
          "color",
          "text",
          "weak"
        ]
      },
      "disabled": {
        "value": "#c7cbcc",
        "type": "color",
        "attributes": {
          "figmaName": "Text/disabled"
        },
        "filePath": "tokens/color/semantics/text.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.gray-50.value}",
          "type": "color",
          "attributes": {
            "figmaName": "Text/disabled"
          }
        },
        "name": "color-text-disabled",
        "path": [
          "color",
          "text",
          "disabled"
        ]
      },
      "danger": {
        "value": "#df5475",
        "type": "color",
        "attributes": {
          "figmaName": "Text/danger"
        },
        "filePath": "tokens/color/semantics/text.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.red-300.value}",
          "type": "color",
          "attributes": {
            "figmaName": "Text/danger"
          }
        },
        "name": "color-text-danger",
        "path": [
          "color",
          "text",
          "danger"
        ]
      },
      "primary": {
        "value": "#4c6072",
        "type": "color",
        "attributes": {
          "figmaName": "Text/primary"
        },
        "filePath": "tokens/color/semantics/text.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.navy-300.value}",
          "type": "color",
          "attributes": {
            "figmaName": "Text/primary"
          }
        },
        "name": "color-text-primary",
        "path": [
          "color",
          "text",
          "primary"
        ]
      },
      "shepinkDefault": {
        "value": "#C38383",
        "type": "color",
        "attributes": {
          "figmaName": "Text/SHEPink/default"
        },
        "filePath": "tokens/color/semantics/text.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.shepink-500.value}",
          "type": "color",
          "attributes": {
            "figmaName": "Text/SHEPink/default"
          }
        },
        "name": "color-text-shepink-default",
        "path": [
          "color",
          "text",
          "shepink-default"
        ]
      },
      "shepinkDarken": {
        "value": "#BA7D7D",
        "type": "color",
        "attributes": {
          "figmaName": "Text/SHEPink/darken"
        },
        "filePath": "tokens/color/semantics/text.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.shepink-600.value}",
          "type": "color",
          "attributes": {
            "figmaName": "Text/SHEPink/darken"
          }
        },
        "name": "color-text-shepink-darken",
        "path": [
          "color",
          "text",
          "shepink-darken"
        ]
      },
      "sheblueDefault": {
        "value": "#6B9BAA",
        "type": "color",
        "attributes": {
          "figmaName": "Text/SHEBlue/default"
        },
        "filePath": "tokens/color/semantics/text.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.sheblue-500.value}",
          "type": "color",
          "attributes": {
            "figmaName": "Text/SHEBlue/default"
          }
        },
        "name": "color-text-sheblue-default",
        "path": [
          "color",
          "text",
          "sheblue-default"
        ]
      },
      "sheblueDarken": {
        "value": "#4D8193",
        "type": "color",
        "attributes": {
          "figmaName": "Text/SHEBlue/darken"
        },
        "filePath": "tokens/color/semantics/text.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.sheblue-600.value}",
          "type": "color",
          "attributes": {
            "figmaName": "Text/SHEBlue/darken"
          }
        },
        "name": "color-text-sheblue-darken",
        "path": [
          "color",
          "text",
          "sheblue-darken"
        ]
      },
      "shegreenDefault": {
        "value": "#729897",
        "type": "color",
        "attributes": {
          "figmaName": "Text/SHEGreen/default"
        },
        "filePath": "tokens/color/semantics/text.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.shegreen-500.value}",
          "type": "color",
          "attributes": {
            "figmaName": "Text/SHEGreen/default"
          }
        },
        "name": "color-text-shegreen-default",
        "path": [
          "color",
          "text",
          "shegreen-default"
        ]
      },
      "shegreenDarken": {
        "value": "#3E6770",
        "type": "color",
        "attributes": {
          "figmaName": "Text/SHEGreen/darken"
        },
        "filePath": "tokens/color/semantics/text.json",
        "isSource": true,
        "original": {
          "value": "{color.primitive.shegreen-600.value}",
          "type": "color",
          "attributes": {
            "figmaName": "Text/SHEGreen/darken"
          }
        },
        "name": "color-text-shegreen-darken",
        "path": [
          "color",
          "text",
          "shegreen-darken"
        ]
      }
    }
  },
  "fontFamily": {
    "default": {
      "value": "-apple-system,'BlinkMacSystemFont','Hiragino Kaku Gothic ProN','Hiragino Sans',Meiryo,sans-serif,'Segoe UI Emoji'",
      "filePath": "tokens/fontfamily/fontfamily.json",
      "isSource": true,
      "original": {
        "value": "-apple-system,'BlinkMacSystemFont','Hiragino Kaku Gothic ProN','Hiragino Sans',Meiryo,sans-serif,'Segoe UI Emoji'"
      },
      "name": "font-family-default",
      "attributes": {},
      "path": [
        "font-family",
        "default:"
      ]
    }
  },
  "space": {
    "100": {
      "value": "0.25rem",
      "filePath": "tokens/spacing/spacing.json",
      "isSource": true,
      "original": {
        "value": "0.25rem"
      },
      "name": "space-100",
      "attributes": {},
      "path": [
        "space",
        "100"
      ]
    },
    "150": {
      "value": "0.375rem",
      "filePath": "tokens/spacing/spacing.json",
      "isSource": true,
      "original": {
        "value": "0.375rem"
      },
      "name": "space-150",
      "attributes": {},
      "path": [
        "space",
        "150"
      ]
    },
    "200": {
      "value": "0.5rem",
      "filePath": "tokens/spacing/spacing.json",
      "isSource": true,
      "original": {
        "value": "0.5rem"
      },
      "name": "space-200",
      "attributes": {},
      "path": [
        "space",
        "200"
      ]
    },
    "250": {
      "value": "0.625rem",
      "filePath": "tokens/spacing/spacing.json",
      "isSource": true,
      "original": {
        "value": "0.625rem"
      },
      "name": "space-250",
      "attributes": {},
      "path": [
        "space",
        "250"
      ]
    },
    "300": {
      "value": "0.75rem",
      "filePath": "tokens/spacing/spacing.json",
      "isSource": true,
      "original": {
        "value": "0.75rem"
      },
      "name": "space-300",
      "attributes": {},
      "path": [
        "space",
        "300"
      ]
    },
    "350": {
      "value": "0.875rem",
      "filePath": "tokens/spacing/spacing.json",
      "isSource": true,
      "original": {
        "value": "0.875rem"
      },
      "name": "space-350",
      "attributes": {},
      "path": [
        "space",
        "350"
      ]
    },
    "400": {
      "value": "1rem",
      "filePath": "tokens/spacing/spacing.json",
      "isSource": true,
      "original": {
        "value": "1rem"
      },
      "name": "space-400",
      "attributes": {},
      "path": [
        "space",
        "400"
      ]
    },
    "500": {
      "value": "1.25rem",
      "filePath": "tokens/spacing/spacing.json",
      "isSource": true,
      "original": {
        "value": "1.25rem"
      },
      "name": "space-500",
      "attributes": {},
      "path": [
        "space",
        "500"
      ]
    },
    "600": {
      "value": "1.5rem",
      "filePath": "tokens/spacing/spacing.json",
      "isSource": true,
      "original": {
        "value": "1.5rem"
      },
      "name": "space-600",
      "attributes": {},
      "path": [
        "space",
        "600"
      ]
    },
    "700": {
      "value": "1.75rem",
      "filePath": "tokens/spacing/spacing.json",
      "isSource": true,
      "original": {
        "value": "1.75rem"
      },
      "name": "space-700",
      "attributes": {},
      "path": [
        "space",
        "700"
      ]
    },
    "800": {
      "value": "2rem",
      "filePath": "tokens/spacing/spacing.json",
      "isSource": true,
      "original": {
        "value": "2rem"
      },
      "name": "space-800",
      "attributes": {},
      "path": [
        "space",
        "800"
      ]
    },
    "900": {
      "value": "2.25rem",
      "filePath": "tokens/spacing/spacing.json",
      "isSource": true,
      "original": {
        "value": "2.25rem"
      },
      "name": "space-900",
      "attributes": {},
      "path": [
        "space",
        "900"
      ]
    },
    "1000": {
      "value": "2.5rem",
      "filePath": "tokens/spacing/spacing.json",
      "isSource": true,
      "original": {
        "value": "2.5rem"
      },
      "name": "space-1000",
      "attributes": {},
      "path": [
        "space",
        "1000"
      ]
    },
    "1200": {
      "value": "3rem",
      "filePath": "tokens/spacing/spacing.json",
      "isSource": true,
      "original": {
        "value": "3rem"
      },
      "name": "space-1200",
      "attributes": {},
      "path": [
        "space",
        "1200"
      ]
    },
    "1400": {
      "value": "3.5rem",
      "filePath": "tokens/spacing/spacing.json",
      "isSource": true,
      "original": {
        "value": "3.5rem"
      },
      "name": "space-1400",
      "attributes": {},
      "path": [
        "space",
        "1400"
      ]
    },
    "1600": {
      "value": "4rem",
      "filePath": "tokens/spacing/spacing.json",
      "isSource": true,
      "original": {
        "value": "4rem"
      },
      "name": "space-1600",
      "attributes": {},
      "path": [
        "space",
        "1600"
      ]
    },
    "2000": {
      "value": "5rem",
      "filePath": "tokens/spacing/spacing.json",
      "isSource": true,
      "original": {
        "value": "5rem"
      },
      "name": "space-2000",
      "attributes": {},
      "path": [
        "space",
        "2000"
      ]
    },
    "2400": {
      "value": "6rem",
      "filePath": "tokens/spacing/spacing.json",
      "isSource": true,
      "original": {
        "value": "6rem"
      },
      "name": "space-2400",
      "attributes": {},
      "path": [
        "space",
        "2400"
      ]
    },
    "050": {
      "value": "0.125rem",
      "filePath": "tokens/spacing/spacing.json",
      "isSource": true,
      "original": {
        "value": "0.125rem"
      },
      "name": "space-050",
      "attributes": {},
      "path": [
        "space",
        "050"
      ]
    }
  },
  "zindex": {
    "hide": {
      "value": "-1",
      "filePath": "tokens/zindex/zindex.json",
      "isSource": true,
      "original": {
        "value": "-1"
      },
      "name": "zindex-hide",
      "attributes": {},
      "path": [
        "zindex",
        "hide:"
      ]
    },
    "auto": {
      "value": "'auto'",
      "filePath": "tokens/zindex/zindex.json",
      "isSource": true,
      "original": {
        "value": "'auto'"
      },
      "name": "zindex-auto",
      "attributes": {},
      "path": [
        "zindex",
        "auto:"
      ]
    },
    "base": {
      "value": "0",
      "filePath": "tokens/zindex/zindex.json",
      "isSource": true,
      "original": {
        "value": "0"
      },
      "name": "zindex-base",
      "attributes": {},
      "path": [
        "zindex",
        "base:"
      ]
    },
    "docked": {
      "value": "10",
      "filePath": "tokens/zindex/zindex.json",
      "isSource": true,
      "original": {
        "value": "10"
      },
      "name": "zindex-docked",
      "attributes": {},
      "path": [
        "zindex",
        "docked:"
      ]
    },
    "dropdown": {
      "value": "1000",
      "filePath": "tokens/zindex/zindex.json",
      "isSource": true,
      "original": {
        "value": "1000"
      },
      "name": "zindex-dropdown",
      "attributes": {},
      "path": [
        "zindex",
        "dropdown:"
      ]
    },
    "sticky": {
      "value": "1100",
      "filePath": "tokens/zindex/zindex.json",
      "isSource": true,
      "original": {
        "value": "1100"
      },
      "name": "zindex-sticky",
      "attributes": {},
      "path": [
        "zindex",
        "sticky:"
      ]
    },
    "banner": {
      "value": "1200",
      "filePath": "tokens/zindex/zindex.json",
      "isSource": true,
      "original": {
        "value": "1200"
      },
      "name": "zindex-banner",
      "attributes": {},
      "path": [
        "zindex",
        "banner:"
      ]
    },
    "overlay": {
      "value": "1300",
      "filePath": "tokens/zindex/zindex.json",
      "isSource": true,
      "original": {
        "value": "1300"
      },
      "name": "zindex-overlay",
      "attributes": {},
      "path": [
        "zindex",
        "overlay:"
      ]
    },
    "modal": {
      "value": "1400",
      "filePath": "tokens/zindex/zindex.json",
      "isSource": true,
      "original": {
        "value": "1400"
      },
      "name": "zindex-modal",
      "attributes": {},
      "path": [
        "zindex",
        "modal:"
      ]
    },
    "popover": {
      "value": "1500",
      "filePath": "tokens/zindex/zindex.json",
      "isSource": true,
      "original": {
        "value": "1500"
      },
      "name": "zindex-popover",
      "attributes": {},
      "path": [
        "zindex",
        "popover:"
      ]
    },
    "skipLink": {
      "value": "1600",
      "filePath": "tokens/zindex/zindex.json",
      "isSource": true,
      "original": {
        "value": "1600"
      },
      "name": "zindex-skip-link",
      "attributes": {},
      "path": [
        "zindex",
        "skipLink:"
      ]
    },
    "toast": {
      "value": "1700",
      "filePath": "tokens/zindex/zindex.json",
      "isSource": true,
      "original": {
        "value": "1700"
      },
      "name": "zindex-toast",
      "attributes": {},
      "path": [
        "zindex",
        "toast:"
      ]
    },
    "tooltip": {
      "value": "1800",
      "filePath": "tokens/zindex/zindex.json",
      "isSource": true,
      "original": {
        "value": "1800"
      },
      "name": "zindex-tooltip",
      "attributes": {},
      "path": [
        "zindex",
        "tooltip:"
      ]
    }
  }
};